import Payment1 from './Payment1';
export default Payment1; 